import type { EngineEvent } from '../../interfaces/websocket-events.interface'
import { addAgentReportEntity } from '../slices/chat.slice'
import { asNumber, asString } from './engine-event-primitives.helper'
import type { WebSocketStoreApi } from './websocket-store.helper'

export const dispatchMasterArtifactReport = (
  store: WebSocketStoreApi,
  event: EngineEvent,
  conversationId: string,
  parentMessageId: string
): void => {
  const artifact = event.data.master_artifact
  if (!artifact || typeof artifact !== 'object') return

  const a = artifact as Record<string, unknown>
  const id = asString(a.id)
  const title = asString(a.title)
  const html = asString(a.content_html)
  if (!id || !html) return

  const format = asString(a.format)
  store.dispatch(
    addAgentReportEntity({
      conversationId,
      parentEventId: parentMessageId,
      agentId: id,
      agentName: title || 'Report',
      reportContent: html,
      eventId: id,
      reportVersion: asNumber(a.version, 1),
      reportId: id,
      isMasterArtifact: true,
      reportFormat: format === 'markdown' ? 'markdown' : 'html',
      turnStartedAt: event.ts,
    })
  )
}
